import styled from 'styled-components'
import { mediaMax } from '../../styles/media'

export const HorizontalListWrapper = styled.div`
  transform: translate3d(0, 0, 0);
  ${mediaMax.md`
    margin: 0 -8px;
    overflow: hidden;
  `}
`

export const HorizontalListTrack = styled.div`
  ${mediaMax.md`
    height: 100%;
    width: 100%;
    overflow-y: hidden;
  `}
`

export const HorizontalListItem = styled.div`
  ${mediaMax.md`
    display: inline-block;
    width: 308px;
    margin: 0 8px;

    &:first-child {
      margin-left: 24px;
    }
  `}
`

export const HorizontalList = styled.div`
  ${mediaMax.md`
    height: 100%;
    overflow-y: auto;
    white-space: nowrap;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;

    padding-bottom: 30px;
    padding-right: 15px;
    margin-bottom: -30px;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`
